import SpotlightSection, { VisualFrame } from "@/components/wynn/SpotlightSection";

function CoachVisual() {
  return (
    <VisualFrame
      badge="Full app only"
      gradient="linear-gradient(135deg, rgba(230,191,255,0.26) 0%, rgba(255,183,198,0.22) 55%, rgba(168,230,255,0.18) 100%)"
    >
      <div className="w-full px-7 md:px-10 space-y-3">
        <div className="flex justify-start">
          <div className="max-w-[82%] border border-[#F4F1EC]/15 bg-[#070608]/45 backdrop-blur-sm px-4 py-3 font-display italic font-light text-[#F4F1EC] text-[17px] leading-snug">
            You don&apos;t have to begin yet — just sit near your materials a moment.
          </div>
        </div>
        <div className="flex justify-end">
          <div className="max-w-[72%] bg-[#F4F1EC] text-[#070608] px-4 py-3 font-body text-[14px] leading-snug">
            I haven&apos;t painted in weeks.
          </div>
        </div>
        <div className="flex justify-start">
          <div className="max-w-[78%] border border-[#F4F1EC]/15 bg-[#070608]/45 backdrop-blur-sm px-4 py-3 font-display italic font-light text-[#F4F1EC] text-[17px] leading-snug">
            What does your studio feel like right now — waiting, or a little distant?
          </div>
        </div>
      </div>
    </VisualFrame>
  );
}

export default function CoachingSpotlight() {
  return (
    <SpotlightSection
      id="coaching"
      testId="wynn-coaching"
      labelColor="#E6BFFF"
      label="AI self-coaching · full app only"
      lead="A companion who"
      accent="understands the work"
      body="Inside the full WYNN app, a gentle, intelligent voice meets you in the moments you feel stuck — listening, never rushing, never turning your practice into a productivity game. It's the one part that lives only in the real app, and it's worth the wait."
      tags={["Always there", "Gentle", "Yours alone"]}
      accentGradient="radial-gradient(50% 55% at 18% 25%, rgba(230,191,255,0.18) 0%, rgba(7,6,8,0) 60%), radial-gradient(50% 55% at 85% 80%, rgba(255,183,198,0.16) 0%, rgba(7,6,8,0) 65%)"
      visual={<CoachVisual />}
    />
  );
}
